var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/AggregatesScoresBlock/ui/AggregatesScoresBlock.less";
import { IconTypes, BadgeTypes } from "../../../constants";
import { Loader } from "sb-resp-ui";
// shared components
import { IncidentItem } from "../../../components";
// block components
import * as CMP from "../components";
import { getPropertyValueOrDefault } from "../../../helpers";
let AggregatesScoresBlock = class AggregatesScoresBlock extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = props.dict;
        // setup data provider
        this.state = {
            dataProvider: props.dataProvider
        };
    }
    render() {
        const currentIncident = this.state.dataProvider.currentIncident;
        const previousIncident = this.state.dataProvider.previousIncident;
        return (React.createElement("div", { className: "rj-aggregate-stats-wrapper" },
            React.createElement("div", { className: `rj-aggregate-stats-container ${this.state.dataProvider.shouldSlideDown && "rj-aggregate-stats-slide-up"}` },
                React.createElement("div", { className: "rj-aggregate-stats-page" },
                    this.props.dataProvider.areScoresLoaded
                        ? React.createElement(CMP.SoccerScoreboard, { dict: this.dict, slideUp: this.state.dataProvider.toggleShouldSlideDown, scores: this.state.dataProvider.scores })
                        : React.createElement("div", { className: "rj-aggregate-scoreboard--empty" },
                            React.createElement(Loader, null)),
                    React.createElement("div", { className: "rj-aggregate-separator" }),
                    this.state.dataProvider.hasCurrentIncident
                        ? React.createElement("div", { className: "rj-incidents-holder" },
                            React.createElement("ul", { className: `rj-incidents-list ${this.state.dataProvider.animationConfiguration.style}` },
                                React.createElement(IncidentItem, { dict: this.dict, incident: currentIncident, key: `incident-${currentIncident.id}`, iconClass: getPropertyValueOrDefault(IconTypes, currentIncident.type), badgeClass: getPropertyValueOrDefault(BadgeTypes, currentIncident.type), latestClasses: "rj-incidents-item-scoreboard" }),
                                previousIncident.id &&
                                    React.createElement(IncidentItem, { dict: this.dict, incident: previousIncident, key: `incident-${previousIncident.id}`, iconClass: getPropertyValueOrDefault(IconTypes, previousIncident.type), badgeClass: getPropertyValueOrDefault(BadgeTypes, previousIncident.type), latestClasses: "rj-incidents-item-scoreboard" })))
                        : React.createElement("div", { className: "rj-incidents-item rj-incidents-item-scoreboard" })),
                React.createElement(CMP.ScoreboardInfo, { dict: this.dict, slideDown: this.state.dataProvider.toggleShouldSlideDown }))));
    }
};
AggregatesScoresBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregatesScoresBlock);
export { AggregatesScoresBlock };
//# sourceMappingURL=AggregatesScoresBlock.js.map